import React, { useEffect, useRef, useState } from 'react';
import { addRegistration, eventSlots, getEventsById, getVisitorsCitizenId } from '../../../axios/Visitor/VisitorApi';
import facialSense_logo from "../../../assets/images/logo/CheckIDBioSense_light.svg";
import { toast } from 'react-toastify';
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import { useAuth } from '../../../context/AuthContext';
import { format } from 'date-fns';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccess3thButton } from '../../../components/StyledButton';
import CustomSelect from '../../../components/CustomSelect';
import AddFileIcon16pxSvg from '../../../assets/images/icons/AddFileIcon16pxSvg';
import ImportDataDialog from './ImportDataDialog';
import EditIcon16pxSvgNew from '../../../assets/images/icons/EditIcon16pxSvgNew';
import CustomInput from '../../../components/CustomInput';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import { CircularProgress } from '@mui/material';
import ShiftRosterIcon20pxSvg from '../../../assets/images/icons/ShiftRosterIcon20pxSvg';
import { FaClock } from 'react-icons/fa6';
import GlobalIcon16pxSvg from '../../../assets/images/icons/GlobalIcon16pxSvg';
import PrivateIcon16pxSvg from '../../../assets/images/icons/PrivateIcon16pxSvg';
import US from '../../../assets/images/flag/US.png';
import VN from '../../../assets/images/flag/VN.png';
import NotFoundPage from '../NotFound/NotFoundPage';
import LocationIcon16pxSvg from '../../../assets/images/icons/LocationIcon16pxSvg';
import WarningIcon20pxSvg from '../../../assets/images/icons/WarningIcon20pxSvg';

const VisitorRegistration = () => {
    const params = new URLSearchParams(window.location.search);

    const visitorURL = params.get("visitorURL");
    const comId = params.get("comid");

    const [eventDetail, setEventDetail] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isNotFound, setIsNotFound] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isExpiredEvent = React.useMemo(() => {
        if (!eventDetail?.registrationEnd) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const endDate = new Date(eventDetail.registrationEnd);
        endDate.setHours(0, 0, 0, 0);

        return endDate < today;
    }, [eventDetail]);

    useEffect(() => {
        if (!visitorURL) return;

        fetchEventDetail();
    }, [visitorURL]);

    const fetchEventDetail = async () => {
        try {
            const payload = {
                id: visitorURL,
                companyId: comId,
                langId: localStorage.getItem("i18nextLngId"),
            };

            const res = await getEventsById(payload);

            if (res?.data?.responseCode === 0) {
                setEventDetail(res.data?.data?.[0]);
            } else {
                setIsNotFound(true);
            }
        } catch (error) {
            console.error(error);

            setIsNotFound(true);
        }
    };

    const { t, i18n } = useTranslation();

    const [openLang, setOpenLang] = useState(false);

    const languages = [
        { code: "vi", label: "Tiếng Việt" },
        { code: "en", label: "English" },
    ];

    const currentLang =
        languages.find((l) => l.code === i18n.language)?.label || "Language";

    const changeLang = (code) => {
        i18n.changeLanguage(code);
        setOpenLang(false);
    };

    const [show, hide] = useLoading();

    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const [openCamera, setOpenCamera] = useState(false);
    const [openFile, setOpenFile] = useState(false);
    const webcamRef = useRef(null);
    const [optionsData, setOptionsData] = useState(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenFile(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const initialFormData = {
        fullName: '',
        citizenIdentificationNumber: '',
        email: '',
        phone: '',
        joinDate: '',
        faceImage: '',
        langId: localStorage.getItem("i18nextLngId"),
        comId: ''
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (comId) {
            setFormData((prev) => ({
                ...prev,
                comId: comId
            }));
        }
    }, [comId]);

    const [validationMessages, setValidationMessages] = useState({
        fullName: "",
        citizenIdentificationNumber: "",
        email: "",
        phone: "",
        joinDate: "",
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    const handleReadCard = (cardId) => {
        try {
            show();
            setReadingCard(true);
            let deviceName = false;

            connectWS.mutate(
                {},
                {
                    onSuccess: (data) => {
                        setIsMissingSoftware(false);
                        hide(); // ẩn loading của connectWS
                        show(); // bật lại loading cho getDevice + readCard

                        getDevice.mutate(
                            { lang: language },
                            {
                                onSuccess: (dataReadcard) => {
                                    if (dataReadcard.deviceSN === "54822502250122") {
                                        deviceName = true;
                                    }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false); // dừng trạng thái reading
                                    toast.error(error.message || error);
                                },
                            }
                        );

                        readCard.mutate(
                            {
                                lang: language,
                                code: cardId.slice(-6),
                                deviceName: deviceName,
                            },
                            {
                                onSuccess: (dataReadcard) => {
                                    hide();
                                    setReadingCard(false);
                                    handleReadCardSuccess(dataReadcard);

                                    if (
                                        dataReadcard.optionalDetails.personalNumber !==
                                        formData.citizenIdentificationNumber
                                    ) {
                                        return setValidationMessages((prev) => ({
                                            ...prev,
                                            citizenIdentificationNumber: "common.content-014",
                                        }));
                                    }

                                    // if (dataReadcard.optionalDetails) {
                                    //     const { fullName } = dataReadcard.optionalDetails;

                                    //     // 👉 chỉ set fullName + image vào form
                                    //     setFormData((prev) => ({
                                    //         ...prev,
                                    //         fullName: fullName || "",
                                    //         faceImage: formatBase64Image(dataReadcard.image) || ""
                                    //     }));

                                    //     // 👉 vẫn giữ toast nếu bạn cần
                                    //     toast.success(t("common.content-013"));
                                    // }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false);
                                    if (error.error === 1102) {
                                        toast.error(t("common.CAN"));
                                    } else {
                                        toast.error(error.message || t("common.content-029"));
                                    }
                                },
                            }
                        );
                    },
                    onError: (error) => {
                        hide(); // **luôn dừng loading**
                        setReadingCard(false);
                        setIsMissingSoftware(true);
                        toast.error(t("common.content-028"));
                    },
                }
            );
        } catch (error) {
            hide(); // **luôn dừng loading**
            setReadingCard(false);
            toast.error(t("common.content-029"));
        }
    };

    const handleReadCardSuccess = (data) => {
        setDataReadcard(data);
        setIsReadCard(true);

        const formattedImage = formatBase64Image(data.image);

        setFormData((prev) => ({
            ...prev,
            faceImage: formattedImage,
            fullName: data.optionalDetails?.fullName || ""
        }));
    };

    const handleCloseDialog = () => {
        setFormData(initialFormData);
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleBlur = async () => {
        if (skipBlurRef.current) {
            skipBlurRef.current = false;
            return;
        }

        const id = formData.citizenIdentificationNumber.trim();

        if (!/^\d{12}$/.test(id)) {
            setValidationMessages((prev) => ({
                ...prev,
                citizenIdentificationNumber: "common.content-009",
            }));
        } else {
            setValidationMessages((prev) => ({
                ...prev,
                citizenIdentificationNumber: "",
            }));

            // CALL API
            await handleGetVisitorByCitizenId(id);

            setonBlurEvent(true);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }
    };

    const handleGetVisitorByCitizenId = async (citizenId) => {
        try {
            const response = await getVisitorsCitizenId({
                citizenIdentificationNumber: citizenId,
                companyId: formData.comId,
            });

            if (
                response?.data?.responseCode === 0 &&
                response?.data?.data?.length > 0
            ) {
                const visitor = response.data.data[0];

                setFormData((prev) => ({
                    ...prev,

                    fullName: visitor?.fullName
                        ? decodeURIComponent(visitor.fullName)
                        : "",

                    email: visitor?.email || "",

                    phone:
                        visitor?.mobile?.replace(
                            selectedPhoneCountry.callingCode,
                            ""
                        ) || "",

                    faceImage: formatBase64Image(visitor?.profileImageUrl) || "",
                }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async () => {
        try {
            if (
                !formData.fullName ||
                !formData.citizenIdentificationNumber ||
                !formData.joinDate ||
                !formData.email ||
                !formData.phone ||
                !formData.faceImage?.trim()
            ) {
                toast.error(
                    !formData.faceImage?.trim()
                        ? t('common.upload-face-image')
                        : t('common.fill-required')
                );
                return;
            }

            setIsSubmitting(true);

            const cleanBase64 = formData.faceImage
                ? formData.faceImage.replace(/^data:image\/\w+;base64,/, "")
                : "";

            const payload = {
                ...formData,
                eventId: visitorURL,
                companyId: formData.comId,
                faceImage: cleanBase64,
                mobile: formData.phone,
            };

            const response = await addRegistration(payload);

            if (response?.data?.responseCode === 0) {
                toast.success(t("common.add-success"));
                setIsSubmitted(true);
            } else {
                toast.error(
                    response?.data?.data?.message ||
                    t("common.something-went-wrong")
                );
            }
        } catch (error) {
            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                t("common.something-went-wrong") ||
                "Something went wrong"
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const generateDateOptions = (start, end) => {
        const result = [];

        const startDate = new Date(start);
        const endDate = new Date(end);

        let current = new Date(startDate);

        while (current <= endDate) {
            result.push({
                label: format(current, genaralSettingDateFormat || "dd/MM/yyyy"),
                value: format(current, "yyyy-MM-dd"),
            });

            current.setDate(current.getDate() + 1);
        }

        return result;
    };

    const fetchSlot = async () => {
        const payload = {
            id: visitorURL || null,
            companyId: comId,
        };
        try {
            show();
            const response = await eventSlots(payload);

            setOptionsData(response?.data?.data || [])

        } catch (error) {
            console.error(error);
        } finally {
            hide();
        }
    };

    useEffect(() => {
        if (visitorURL) {
            fetchSlot();
        }
    }, [visitorURL]);

    const dateOptions = React.useMemo(() => {
        if (!optionsData?.length) return [];

        return optionsData.map((item) => {
            const isFull = item.totalUse >= item.maxDailySlot;

            return {
                label: format(new Date(item.eventDate), "dd/MM/yyyy"),
                value: item.eventDate,
                disabled: isFull,
                totalUse: item.totalUse,
                maxDailySlot: item.maxDailySlot,
            };
        });
    }, [optionsData]);

    const fileInputRef = useRef(null);

    const handleOpenFile = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData((prev) => ({
                ...prev,
                faceImage: reader.result, // base64
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleOpenCamera = async () => {
        try {
            // check camera permission + device
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // stop ngay để tránh giữ camera
            stream.getTracks().forEach(track => track.stop());

            setOpenFile(true);
        } catch (error) {
            toast.error(t("common.no-camera") || "Thiết bị không có camera hoặc bị từ chối quyền");
        }
    };

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    const isFullEvent = React.useMemo(() => {
        if (!eventDetail?.maxParticipants || !optionsData?.length) {
            return false;
        }

        const totalRegistered = optionsData.reduce(
            (sum, item) => sum + (item.totalUse || 0),
            0
        );

        return totalRegistered >= eventDetail.maxParticipants;
    }, [optionsData, eventDetail]);

    if (isNotFound) {
        return <NotFoundPage />;
    }

    return (


        <>
            <div className="min-h-screen bg-gradient-to-b from-white to-[#DBE8FF] flex flex-col items-center px-4 pb-5">

                {/* HEADER */}
                <div className="w-full flex items-center justify-between py-4">
                    {/* Logo */}
                    <img
                        src={facialSense_logo}
                        alt="logo"
                        className="h-14 w-auto"
                        width={200}
                        height={50}
                    />

                    <div className="relative">
                        <button
                            onClick={() => setOpenLang(!openLang)}
                            className="
                flex items-center gap-2
                px-3 py-2
                border border-[#E5E7EB]
                rounded-xl
                bg-white
                hover:bg-gray-50
            "
                        >
                            {/* circle icon */}
                            <img
                                src={i18n.language === "vi" ? VN : US}
                                alt="flag"
                                className="w-6 h-6 rounded-full object-cover"
                            />

                            <span className="text-sm text-gray-700">
                                {currentLang}
                            </span>

                            {/* arrow */}
                            <svg
                                className={`w-4 h-4 transition-transform ${openLang ? "rotate-180" : ""}`}
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>

                        {/* DROPDOWN */}
                        {openLang && (
                            <div className="absolute right-0 mt-2 w-40 bg-white border border-[#E5E7EB] rounded-lg shadow-lg z-50 overflow-hidden">
                                {languages.map((lang) => (
                                    <button
                                        key={lang.code}
                                        onClick={() => changeLang(lang.code)}
                                        className={`
                            w-full text-left px-3 py-2 text-sm
                            hover:bg-gray-100
                            ${i18n.language === lang.code ? "bg-gray-50 font-semibold" : ""}
                        `}
                                    >
                                        {lang.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-full max-w-xl">
                    {/* EVENT HEADER */}
                    {/* {eventDetail && ( */}
                    <div style={{
                        background: "linear-gradient(to bottom, #0575E6, #02298A, #021B79)"
                    }} className="p-4 rounded-lg text-white">
                        <h2 className="text-xl font-semibold">
                            {eventDetail?.name || "Event"}
                        </h2>

                        <div className="text-sm mt-2 text-[#FCFCFC] flex items-center gap-2 opacity-90">

                            <LocationIcon16pxSvg color="#FCFCFC" className="w-5 h-5 flex-shrink-0" />

                            <span>
                                {eventDetail?.address}
                            </span>
                        </div>

                        <div className="text-sm mt-2 text-[#FCFCFC] flex items-center gap-2 opacity-90">

                            <ShiftRosterIcon20pxSvg color="#FCFCFC" className="w-5 h-5 flex-shrink-0" />

                            {eventDetail?.startDate && eventDetail?.endDate && (
                                <>
                                    {format(new Date(eventDetail.startDate), "dd/MM/yyyy")} -{" "}
                                    {format(new Date(eventDetail.endDate), "dd/MM/yyyy")}
                                </>
                            )}

                            <FaClock className="w-4 h-4 flex-shrink-0" />

                            <span>
                                {eventDetail?.startTime?.slice(0, 5)} - {eventDetail?.endTime?.slice(0, 5)}
                            </span>

                        </div>

                        <div className="text-sm mt-2 opacity-90">
                            {isExpiredEvent ? (
                                <div
                                    className="inline-flex items-center gap-1 px-2 py-1 rounded-2xl border"
                                    style={{
                                        backgroundColor: "#FEF2E6",
                                        border: "1px solid #F97C00",
                                        color: "#F97C00",
                                    }}
                                >
                                    <FaClock
                                        style={{
                                            fontSize: 16,
                                            color: "#F97C00",
                                        }}
                                    />

                                    {t("common.expired-event-deadline", { deadline: format(new Date(eventDetail?.registrationEnd), "dd/MM/yyyy") })}
                                </div>
                            ) : isFullEvent ? (
                                <div
                                    className="inline-flex items-center gap-1 px-2 py-1 rounded-2xl border"
                                    style={{
                                        backgroundColor: "#FAE7E6",
                                        border: "1px solid #D00D00",
                                        color: "#D00D00",
                                    }}
                                >
                                    <WarningIcon20pxSvg className="w-5 h-5" />

                                    {t("common.fully-booked", { filled: eventDetail?.maxParticipants || 0, total: eventDetail?.maxParticipants || 0 })}
                                </div>
                            ) : eventDetail?.isPublic ? (
                                <div
                                    className="inline-flex items-center gap-1 px-2 py-1 rounded-2xl border"
                                    style={{
                                        backgroundColor: "#F0FDF4",
                                        border: "1px solid #058900",
                                        color: "#058900",
                                    }}
                                >
                                    <GlobalIcon16pxSvg color="#058900" />

                                    {t("common.public-event")}
                                </div>
                            ) : (
                                <div
                                    className="inline-flex items-center gap-1 px-2 py-1 rounded-2xl border"
                                    style={{
                                        backgroundColor: "#F0FDF4",
                                        border: "1px solid #0EA5E9",
                                        color: "#0EA5E9",
                                    }}
                                >
                                    <PrivateIcon16pxSvg color="#0EA5E9" />

                                    {t("common.private-event")}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* )} */}

                    {/* CARD */}
                    <div
                        className="w-full max-w-xl bg-white rounded-xl shadow-lg p-6 border-t-[12px]"
                        style={{
                            borderTopColor: isExpiredEvent
                                ? "#F97C00" : isFullEvent
                                    ? "#D00D00"
                                    : isSubmitted
                                        ? "#058900"
                                        : "#0575E6",
                        }}
                    >
                        {isExpiredEvent ? (
                            <div className="text-start">
                                <h2 className="text-2xl font-bold text-[#1F2937]">
                                    {t("common.event-expired")}
                                </h2>

                                <p className="text-[#1F2937] mt-2">
                                    {t("common.event-expired-description", { deadline: format(new Date(eventDetail?.registrationEnd), "dd/MM/yyyy") })}
                                </p>
                            </div>
                        ) : isFullEvent ? (
                            <div className="text-start">
                                <h2 className="text-2xl font-bold text-[#1F2937]">
                                    {t("common.event-full")}
                                </h2>

                                <p className="text-[#1F2937] mt-2">
                                    {t("common.event-full-description")}
                                </p>
                            </div>
                        ) : isSubmitted ? (
                            <div className="text-start">
                                <h2 className="text-2xl font-bold text-[#1F2937]">
                                    {t('common.registered')}
                                </h2>

                                <p className="text-[#6B7280] mt-2">
                                    {t('common.registered-des')}
                                </p>
                            </div>
                        ) : (<>
                            {/* FORM */}
                            <div className='space-y-4'>
                                <div className="w-full">
                                    <h2 className='text-lg font-bold text-[#1F2937]'>{t('common.registrationdetails')}</h2>
                                    <p className='text-[#6B7280]'>{t('common.registrationdetailsdes')}</p>
                                </div>
                                <div className="w-full">
                                    <div className="relative flex flex-col items-center">

                                        {/* TOP LEFT BROWSER */}
                                        {!formData.faceImage && (
                                            <div className="w-full flex justify-start mb-4">
                                                <div className='flex flex-col gap-2'>
                                                    <p className='text-[#1F2937]'>
                                                        {t('common.profilepicture')}
                                                        <span className="text-red-500">*</span>
                                                    </p>

                                                    <p className='text-[#9CA3AF]'>
                                                        {t('common.uploaddes')}
                                                    </p>

                                                    <ControlpanelSuccess3thButton
                                                        onClick={() => setOpenFile(true)}
                                                        className="flex items-center gap-2 px-4 h-full text-[#FCFCFC] hover:bg-[#00308C] max-w-[120px]"
                                                    >
                                                        <AddFileIcon16pxSvg color='#0057FF' />
                                                        {t("common.browser")}
                                                    </ControlpanelSuccess3thButton>
                                                </div>
                                            </div>
                                        )}

                                        {/* CENTER IMAGE */}
                                        {formData.faceImage && (
                                            <div className="relative">
                                                <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px] bg-white">
                                                    <img
                                                        src={formData.faceImage}
                                                        alt="preview"
                                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                                    />
                                                </div>

                                                {/* FLOATING EDIT BUTTON */}
                                                <button
                                                    ref={anchorRefAdvanced}
                                                    onClick={() => setOpenFile(true)}
                                                    className="
                        absolute
                        bottom-0
                        right-0
                        w-10
                        h-10
                        rounded-xl
                        bg-[#0057FF]
                        hover:bg-[#00308C]
                        flex
                        items-center
                        justify-center
                        shadow-lg
                        transition
                    "
                                                >
                                                    <EditIcon16pxSvgNew />
                                                </button>
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            accept="image/*"
                                            capture="environment"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            hidden
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label>{t('common.name')} <span className="text-red-500">*</span></label>
                                    <CustomInput name='fullName' placeholder={t('placeholder.name')} value={formData.fullName} handleInputChange={handleInputChange} />
                                </div>

                                <div>
                                    <label>{t('common.personal-id')}<span className="text-red-500">*</span></label>
                                    <div className="mt-2 relative flex items-center">
                                        <input
                                            type="number"
                                            name="citizenIdentificationNumber"
                                            className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.citizenIdentificationNumber ? "invalid" : ""
                                                }`}
                                            value={formData.citizenIdentificationNumber}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // ✅ Chỉ cho phép tối đa 12 chữ số
                                                if (value.length <= 12) {
                                                    handleInputChange(e);
                                                    setFormData((prev) => ({ ...prev }));
                                                }
                                            }}
                                            placeholder={t('placeholder.personal-id')}
                                        />
                                        {/* <ControlpanelPrimaryButton
                                            disabled={
                                                !!validationMessages.citizenIdentificationNumber || !formData.citizenIdentificationNumber || readingCard
                                            }
                                            className={`w-[6.25rem] !absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 ${!!validationMessages.citizenIdentificationNumber ||
                                                !formData.citizenIdentificationNumber ||
                                                formData.citizenIdentificationNumber.length !== 12
                                                ? "opacity-50"
                                                : ""
                                                }`}
                                            onMouseDown={() => (skipBlurRef.current = true)}
                                            onClick={() => handleReadCard(formData.citizenIdentificationNumber)}
                                        >
                                            {readingCard ? (
                                                <CircularProgress size={18} color="inherit" />
                                            ) : (
                                                t("button.read-card")
                                            )}
                                        </ControlpanelPrimaryButton> */}
                                    </div>
                                </div>

                                <div>
                                    <label>{t('common.email')} <span className="text-red-500">*</span></label>
                                    <div className="mt-2 relative flex items-center h-10">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control h-10 pr-10"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder={"name@example.com"}
                                        />
                                    </div>

                                    {/* MESSAGE */}
                                    {validationMessages.email && (
                                        <p className="mt-2 text-sm text-red-500">
                                            {t(validationMessages.email)}
                                        </p>
                                    )}
                                </div>

                                <div className="space-y-2 col-span-2">
                                    <label className="block">{t("common.phone")} <span className="text-red-500">*</span></label>
                                    <div className="relative flex items-center h-10">
                                        {/* <div className="flex items-center jus gap-1 ps-3.5 relative z-10">
                                            <img
                                                src={selectedPhoneCountry.nationFlag}
                                                alt="flag-icon"
                                                className="w-6"
                                            />
                                            <span className="text-black">
                                                {selectedPhoneCountry.callingCode}
                                            </span>
                                        </div> */}
                                        <input
                                            className={`absolute inset-0 -top-[1px] form-control h-10`}
                                            value=""
                                            onChange={() => { }}
                                        />
                                        <input
                                            type="number"
                                            placeholder={selectedPhoneCountry.placeHolder}
                                            name="phone"
                                            className="no-spin-buttons relative z-10 flex-1 h-10 outline-none pl-4 border-none rounded-r-md bg-transparent item-center"
                                            onChange={handleInputChange}
                                            value={formData.phone}
                                        />
                                        {formData.phone && !validationMessages.phone && (
                                            <span className="absolute inset-y-[-4px] right-0 px-3 py-3">
                                                <DoneIcon fontSize="small" className="text-green-500" />
                                            </span>
                                        )}
                                        {!!validationMessages.phone && (
                                            <span className="absolute inset-y-[-4px] right-0 px-3 py-3">
                                                <ErrorIcon fontSize="small" className="text-red-500" />
                                            </span>
                                        )}
                                    </div>
                                    {validationMessages.phone && (
                                        <p className="text-sm text-red-500 mt-1">
                                            {t(validationMessages.phone)}
                                        </p>
                                    )}
                                </div>

                                <div className="border-t border-[#E5E7EB] pt-2 mt-4">
                                    <label>
                                        {t('common.select-date')}
                                    </label>

                                    <span className='text-[#EF4444] ml-1'>*</span>

                                    <CustomSelect
                                        name="joinDate"
                                        value={formData.joinDate}
                                        options={dateOptions}
                                        onChange={(e) => handleDataChange("joinDate", e.target.value)}
                                        className="!mt-2"
                                        dataType="joinDate"
                                        placeholder={t('common.select-date')}
                                        renderOption={(option) => (
                                            <div className="flex items-center justify-between w-full">
                                                <span>{option.label}</span>

                                                <span
                                                    className={`text-sm bg-[#F3F4F6] px-3 py-1 rounded-full ${option.disabled
                                                        ? "text-red-500"
                                                        : "text-[#1F2937]"
                                                        }`}
                                                >
                                                    {option.totalUse}/{option.maxDailySlot}
                                                </span>
                                            </div>
                                        )}
                                    />
                                </div>
                            </div>

                            {/* FOOTER BUTTON */}
                            <div className="mt-6 flex items-center justify-between">

                                {/* DELETE ALL */}
                                <button
                                    type="button"
                                    onClick={() => {
                                        setFormData({
                                            fullName: "",
                                            citizenIdentificationNumber: "",
                                            email: "",
                                            phone: "",
                                            joinDate: "",
                                            faceImage: "",
                                            langId: localStorage.getItem("i18nextLngId"),
                                        });

                                        setValidationMessages({
                                            fullName: "",
                                            citizenIdentificationNumber: "",
                                            email: "",
                                            phone: "",
                                            joinDate: "",
                                        });
                                    }}
                                    className="text-sm text-[#0057FF] hover:text-[#0057FF] transition"
                                >
                                    {t("common.delete-all-replies")}
                                </button>

                                {/* SUBMIT */}
                                <ControlpanelPrimaryButton
                                    onClick={handleSubmit}
                                    disabled={
                                        isSubmitting ||
                                        !formData.fullName ||
                                        !formData.citizenIdentificationNumber ||
                                        !formData.joinDate ||
                                        !formData.email ||
                                        !formData.phone ||
                                        !formData.faceImage?.trim()
                                    }
                                >
                                    {isSubmitting ? (
                                        <CircularProgress size={18} color="inherit" />
                                    ) : (
                                        t("common.registernow")
                                    )}
                                </ControlpanelPrimaryButton>

                            </div>

                        </>)}
                    </div>
                </div>


            </div>
            {openFile && (
                <ImportDataDialog
                    onClose={() => setOpenFile(false)}
                    onConfirm={(base64) => {
                        setFormData((prev) => ({
                            ...prev,
                            faceImage: base64,
                        }));

                        setOpenFile(false);
                    }}
                />
            )}
        </>
    );
};

export default VisitorRegistration;